import { render, staticRenderFns } from "./WorkflowProcessListPane.vue?vue&type=template&id=2f0f7564&scoped=true"
import script from "./WorkflowProcessListPane.vue?vue&type=script&lang=js"
export * from "./WorkflowProcessListPane.vue?vue&type=script&lang=js"
import style0 from "./WorkflowProcessListPane.vue?vue&type=style&index=0&id=2f0f7564&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0f7564",
  null
  
)

export default component.exports